import { useLensApp } from "../useLensApp.jsx";

export default function CameraSection() {
  const {
    cameraMode, cameraTransition, cameras, settings,
    source, sourceFormatKey, sourceFormatOptions, virtualCameraStatusText, runtimeStatus, actions,
  } = useLensApp();
  const cameraDeviceId = settings?.cameraDeviceId || "";
  const virtualDeviceOn = Boolean(runtimeStatus?.status?.vcamStarted);
  const modes = [
    { value: "off", label: "Release", detail: "Use elsewhere" },
    { value: "preview", label: "Preview", detail: "Show here" },
    {
      value: "virtual-camera",
      label: "Virtual",
      detail: cameraTransition === "virtual-camera" ? "Starting…" : (virtualDeviceOn ? "Device on" : "Device stopped"),
    },
  ];

  return (
    <section className="camera-section">
      <div className="section-heading-row">
        <div>
          <h3>Camera</h3>
          <div className="hint flush">Only one mode owns the physical camera</div>
        </div>
        {cameraTransition && <span className="mode-working">Switching…</span>}
      </div>

      <div className="camera-mode-picker" role="group" aria-label="Camera mode">
        {modes.map((mode) => (
          <button
            key={mode.value}
            type="button"
            className={cameraMode === mode.value ? "selected" : ""}
            aria-pressed={cameraMode === mode.value}
            disabled={Boolean(cameraTransition)}
            data-device-on={mode.value === "virtual-camera" && virtualDeviceOn ? "true" : undefined}
            onClick={() => actions.setCameraMode(mode.value).catch(actions.setError)}
          >
            <strong>{mode.label}</strong>
            <span>{mode.detail}</span>
          </button>
        ))}
      </div>

      <div className="camera-mode-status" data-mode={cameraMode}>
        <span aria-hidden="true" />
        {cameraMode === "off"
          ? "LensCore is not holding your camera."
          : (cameraMode === "preview"
            ? "The camera is rendered in this preview."
            : virtualCameraStatusText)}
      </div>

      <div className="field">
        <label htmlFor="cameraSelect">Physical camera</label>
        <select
          id="cameraSelect"
          value={cameraDeviceId}
          disabled={Boolean(cameraTransition)}
          onChange={(event) => actions.selectCamera(event.target.value).catch(actions.setError)}
        >
          <option value="">Default camera</option>
          {cameras.map((camera) => (
            <option key={camera.deviceId} value={camera.deviceId}>
              {camera.label || "Unnamed camera"}
            </option>
          ))}
        </select>
      </div>
      <div className="field">
        <div className="field-label-row">
          <label htmlFor="sourceFormatSelect">Capture mode</label>
          <button
            type="button"
            className="text-button"
            disabled={Boolean(cameraTransition)}
            onClick={() => actions.enumerateCameras().catch(actions.setError)}
          >
            Refresh
          </button>
        </div>
        <select
          id="sourceFormatSelect"
          value={sourceFormatKey}
          disabled={Boolean(cameraTransition)}
          onChange={(event) => actions.applySourceFormat(event.target.value).catch(actions.setError)}
        >
          {sourceFormatOptions.map((option) => (
            <option key={option.key} value={option.key}>{option.label}</option>
          ))}
        </select>
        <div className="hint flush capture-mode-result">
          {source
            ? `Active: ${source.width || "?"}x${source.height || "?"} @ ${source.fps || "?"}fps`
            : "Modes are read from the selected camera; Active appears after capture starts."}
        </div>
      </div>
    </section>
  );
}
